import {Injectable} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CurrentPlatformService } from 'src/app/services/current-platform.service';
import { ConnectionStatus, Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root'
})
export class NetworkStateService {

  networkStatus$: BehaviorSubject<ConnectionStatus> = new BehaviorSubject<ConnectionStatus>({ connected: false, connectionType: 'none' });

  constructor(private platform: CurrentPlatformService) {
    this.platform.ready().then(() => {
      this.initializeNetworkEvents();
    });
  }

  private async initializeNetworkEvents() {
    const initialStatus = await Network.getStatus();
    this.networkStatus$.next(initialStatus);

    Network.addListener('networkStatusChange', (status) => {
      this.networkStatus$.next(status);
    });
  }

  public getNetworkStatus(): Observable<ConnectionStatus> {
    return this.networkStatus$.asObservable();
  }
  
  public isOnline(): boolean {
    return this.networkStatus$.getValue().connected;
  }
}